export default "__VITE_ASSET__CVilw5AI__"